import "./App.css";
import { ThreeDimAlgorithm } from "./components/Applications/3DAlgorithm/ThreeDimAlgorithm";
import { HelloWorld } from "./components/Applications/HelloWorld/HelloWorld";
import { InteractiveCV } from "./components/Applications/InteractiveCV/InteractiveCV";
import { PDFViewer } from "./components/Applications/PDFViewer/PDFViewer";
import { LegalNotice } from "./components/Applications/LegalNotice/LegalNotice";
import { SudokuSolver } from "./components/Applications/SudokuSolver/SudokuSolver";
import { OS } from "./components/System/OS/OS";
import HelloWorldIcon from "url:./assets/HelloWorldIcon.png";
import InteractiveCVIcon from "url:./assets/InteractiveCVIcon.svg";
import ThreeDimAlgorithmIcon from "url:./assets/logo-3D.svg";
import PDFViewerIcon from "url:./assets/Icon_pdf_file.svg";
import LegalNoticeIcon from "url:./assets/justice.svg";
import SudokuSolverIcon from "url:./assets/SudokuSolverIcon.svg";
import { OpenLink } from "./components/Applications/OpenLink/OpenLink";
import { PhotoGallery } from "./components/Applications/PhotoGallery/PhotoGallery";
import PhotoGalleryIcon from "url:./assets/Icon_photo_gallery.svg";

const PATH = [
    {
        command: "hello-world",
        component: HelloWorld,
        icon: HelloWorldIcon,
        title: {
            En: "Hello World",
            Fr: "Bonjour le monde",
        },
        visible: false,
        defaultargs: {
            title: {
                En: "Hello World!",
                Fr: "Bonjour le monde !",
            },
        },
        newtabicon: false,
    },
    {
        command: "interactive-cv",
        component: InteractiveCV,
        icon: InteractiveCVIcon,
        title: {
            En: "Interactive CV",
            Fr: "CV interactif",
        },
        visible: true,
        defaultargs: {},
        newtabicon: false,
    },
    {
        command: "pdf-viewer",
        component: PDFViewer,
        icon: PDFViewerIcon,
        title: {
            En: "PDF Viewer",
            Fr: "Visionneuse PDF",
        },
        visible: false,
        defaultargs: {
            url: "",
        },
        newtabicon: false,
    },
    {
        command: "3d-algorithm",
        component: ThreeDimAlgorithm,
        icon: ThreeDimAlgorithmIcon,
        title: {
            En: "3D Algorithm",
            Fr: "Algorithme 3D",
        },
        visible: true,
        defaultargs: {},
        newtabicon: false,
    },
    {
        command: "photo-gallery",
        component: PhotoGallery,
        icon: PhotoGalleryIcon,
        title: {
            En: "Photo Gallery",
            Fr: "Galerie photo",
        },
        visible: true,
        defaultargs: null,
        newtabicon: false,
    },
    {
        command: "github",
        component: OpenLink,
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
        title: {
            En: "My GitHub",
            Fr: "Mon GitHub",
        },
        visible: true,
        defaultargs: {
            url: "https://github.com/IooGoZ",
        },
        newtabicon: true,
    },
    {
        command: "linkedin",
        component: OpenLink,
        icon: "https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg",
        title: {
            En: "My LinkedIn",
            Fr: "Mon LinkedIn",
        },
        visible: true,
        defaultargs: {
            url: "https://www.linkedin.com/in/tom-boireau/",
        },
        newtabicon: true,
    },
    {
        command: "sudoku-solver",
        component: SudokuSolver,
        icon: SudokuSolverIcon,
        title: {
            En: "Sudoku Solver",
            Fr: "Solveur Sudoku",
        },
        visible: true,
        defaultargs: {},
        newtabicon: false,
        minWidth: 820,
        minHeight: 820,
    },
    {
        command: "legal-notice",
        component: LegalNotice,
        icon: LegalNoticeIcon,
        title: {
            En: "Legal Notice",
            Fr: "Mentions légales",
        },
        visible: true,
        defaultargs: {},
        newtabicon: false,
    },
];

export function App() {
    return <OS path={PATH} />;
}
